<template>
    <a-modal title="解除企业绑定"
             :width="700"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="$emit('cancel')"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <table style="width:100%" class="fx-form">
                <tr>
                    <th  >账号：</th>
                    <td>
                        <a-form-item>
                            {{account.account}}
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th  >账号类型：</th>
                    <td>
                        <a-form-item>
                            {{account.accountType === '1' ? '管理员' : '普通用户'}}
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th  >注册时间：</th>
                    <td>
                        <a-form-item>
                            {{account.crtTime}}
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th  >统一社会信用代码：</th>
                    <td>
                        <a-form-item>
                            {{account.creditCode}}
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th  >绑定的企业：</th>
                    <td>
                        <a-form-item>
                            {{account.supplierName }}
                        </a-form-item>
                    </td>
                </tr>


                <tr>
                    <th  >操作:</th>
                    <td>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a-button type="danger" @click="sysInfo">解除</a-button>
                    </td>
                </tr>

            </table>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                userName: '',
                orgName: '',
                actions: [
                    {type: 'bank', text: '广东省环境监测中心'},
                    {type: 'clock-circle', text: '发布时间：今天10: 30 '},
                ],
                dealData: [],
                todayData: [],
                historyData: [],
                queryParam: {},
                id: this.$route.query.id,
                modalLoading: false,
                params: {},
                loading: false,
                account: ''
            }
        },
        methods: {
            initInfo(id) {
                let that = this
                this.$http.get('/api/v1/supplier/account/get_account_info.json?id='+id).then(function (res) {
                    that.account = res.result.account
                })
            },
            onSubmit() {
            },
            confirmPassword () {
            },
            sysInfo() {
                debugger
                    if (this.account.accountType === '1'){
                        this.$message.warn("管理员必须移交身份后才可解除绑定!")
                        return
                    }
                    let that = this
                    this.$confirm({
                        title: '你确定要解除企业绑定吗?',
                        content:"解除后将与该单位无任何关联!",
                    onOk(){
                        that.unBind()
                    },
                    onCancel(){
                        console.log('Cancel');
                    }
                });
            },
            fixedAccount(rule, value, callback) {
            },
            unBind() {
                let that = this
                this.$http.get('/api/v1/supplier/account/unBind.json').then(function (res) {
                    if (res.code === 200) {
                        that.$message.info(res.msg);
                        that.$router.go(0);
                        // that.$router.push({path:'/index'})
                    }else if (res.code === 100) {
                        that.$message.error(res.msg);
                    }
                });
            }
        }
    };
</script>
<style lang="less" scoped>
    .fx-form th{
        width: 160px;
    }
</style>
